<template>
    <div>
        <section class="header-gradient padd-bottom-50">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <div class="dash-heading">
                            Candidate Dashboard
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "candidateBanner"
    }
</script>
<style scoped>
    .padd-bottom-50{
        margin-bottom: 50px;
    }
</style>